import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component } from 'intact-vue';
import template from './index.vdt';
import { bind } from '../utils';
import { useConfigContext } from '../config';
export * from './step';
var typeDefs = {
  value: Number,
  status: ['normal', 'error', 'done'],
  type: ['default', 'line', 'simple', 'line-compact', 'dot'],
  clickable: Boolean,
  vertical: Boolean
};
var defaults = function defaults() {
  return {
    value: 0,
    status: 'normal',
    type: 'default'
  };
};
export var Steps = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Steps, _Component);
  function Steps() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Steps.prototype;
  _proto.changeIndex = function changeIndex(index) {
    var _this$get = this.get(),
      value = _this$get.value,
      clickable = _this$get.clickable;
    if (clickable && value > index) {
      this.set('value', index);
    }
  };
  return Steps;
}(Component);
Steps.template = template;
Steps.typeDefs = typeDefs;
Steps.defaults = defaults;
__decorate([bind], Steps.prototype, "changeIndex", null);